import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import Dashboard from '../components/Menu/Dashboard';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { isMobile } from 'react-device-detect';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import TaxeRenderBody from '../components/Taxes/TaxeRenderBody';
import TaxePanel from '../components/Taxes/TaxePanel';
import StandardDialog from '../components/Complements/StandardDialog';
import DialogOTP from '../components/Complements/DialogOTP';
import TaxeInfoPanel from '../components/Taxes/TaxeInfoPanel';
import CreditsForm from '../components/Credits/CreditsForm';
import { processGetCreditsAditionalPayment, processCreditsPay, GetOTP, getSecurityTokenService } from '../services/coreProcess';
import { history } from '../helpers/history';
import { isEmpty } from '../functions/arrays';
import Voucher from '../components/Transfers/Voucher';
import { sendEmailWithVoucher } from "../actions/sendEmailWithVoucher";
import { urlVoucher } from '../services/urls';
import MessageInfo from './../components/Complements/MessageInfo';
import { changeStatusUser } from './../actions/codes'
import { getBalanceUser } from "./../actions/balances";
import { validateIp } from '../functions/store';
import { encrypt, sendMobile } from '../functions/mobile';
import moment from 'moment'
import { feathersCreateData } from '../services';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';

const CreditsPayContainer = props => {
    const { user, balances, handleOpenSnack, credits, devices, getDeviceData, updateIpDevice, parameters } = props
    const [ accountSelected, setAccountSelected ] = useState(balances[0])
    const [ creditSelected, setCreditSelected ] = useState({})
    const [ creditProcess, setCreditProcess ] = useState({})
    const [ showvoucher, setShowvoucher ] = useState(false)
    const [ dataresponse, setDataresponse ] = useState({})
    const [ show, setShow ] = useState(true)
    const [ dataCreditSelected, setDataCreditSelected ] = useState("")
    const [ showDialogAccounts, setShowDialogAccounts ] = useState(false)
    const [ valuePay, setValuePay ] = useState(0)
    const [ loading, setLoading ] = useState(false)
    const [dialog, setDialog] = useState({
        state: false,
        title: '',
        content: <div></div>
    })
    const [ formTaxe, setFormTaxe ] = useState({
        agreements: {},
        levels: {},
        periods: {},
        concept: '',
        description: '',
        payersCode: [],
        payerSelected: [],
        payerValue: 0,
        payerData: {}
    })
    const [ OTP, setOTP ] = useState({
        id: '',
        openOtp: false,
        type: '',
        code: ''
    })

    const mount = () => {
        const unmount = () => {
            handleGetStateTokenService()
        }
        return unmount()
    }

    useEffect(mount, []) 

    // functions
    const sum = (key, array) =>  {
        return array.reduce((a, b) => a + (b[key] || 0), 0);
    }
    const cleanDialog = () => {
        setDialog({
            state: false,
            title: '',
            content: <div></div>
        })
    }

    const handleGetStateTokenService = () => {

        try{
            setLoading(true)
            getSecurityTokenService().then(res => {
                //console.log(res)
                const { PuedeTransaccionar } = res.data;
                if(PuedeTransaccionar === false) {
                    handleOpenSnack('Por el momento el servicio no se encuentra habilitado. Por favor intente mas tarde.', 'info')
                    history.push('/')
                } 
                setLoading(false)
            }).catch(err => {
                //console.log(err)
                setLoading(false)
            }) 

        }catch(error){

        }
    }

    const handleAccountChange = () => {
        setShowDialogAccounts(!showDialogAccounts)
    }

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput.target.value.toString().length === 4){
            handleOTPCompare({data : valueinput.target.value.toString()});
        }

    }

    const handleDownloadVoucher = () => {
        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataresponse.NumeroDocumento, name_voucher: dataresponse.name_voucher})().then(res => {
            if (res.error) {
                handleOpenSnack(res.message, 'error')
            } else {
                if (localStorage.caja_app !== undefined) {
                    // let send = {
                    //     type: 'action',
                    //     action: 'download_voucher',
                    //     data: urlVoucher+res.voucher+".pdf",
                    //     messageSend: 'Comprobante'
                    // }
                    // sendMobile(JSON.stringify(send))
                    handleDownloadMovil(urlVoucher, res.voucher)
                    
                } else {
                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                    handleDownloadWeb(urlVoucher, res.voucher)
                }
            }
        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
    }

    const handleUpdatedBalances = async() => {
        await props.getBalanceUser({NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true}).then( res => {
            
            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.Secuencial === accountSelected.Secuencial) ? true : false;
                
            })

            setAccountSelected(getdataaccountselected[0])

        })
        .catch(err=> {
            //console.log(' error al obtener balances ', err)
        })
    }

    // handle
    const handleOTPCompare = async({data}) => {
        // const { id } = auth
        try {
            setLoading(true)
            const { type } = OTP
            
            if (type === 'CREDIT_PROCESS') {

                const {ip, device, mac} = devices

                const sendData = encrypt(JSON.stringify({
                    ip,
                    mac,
                    device,
                    type : 20,
                    inputOtp : data
                }))
                
                const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

                //console.log("Respuesta: ", responseValidateCode)

                //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

                //console.log(responseValidateCodeDecrypt)

                const { error, message, type : typeMessage, viewDialogOtp } = responseValidateCode;
                if (error === false) {
                    // const { agreements, levels, periods, concept, payerSelected } = formTaxe
                    // proceso de pago de creditos o prestamos

                    const sendDataCredits = encrypt(JSON.stringify({
                        ...creditProcess, 
                        otp : data
                    }))
                    processCreditsPay({ sendData : sendDataCredits }).then(res => {
                        //console.log(res)
                        const { message, type:tp, error } = res

                        if(error === false){
                            handleUpdatedBalances()
                            setDataresponse(res.data)
                            setShowvoucher(true)
                            setOTP({...OTP, openOtp: false})
                        }

                        handleOpenSnack(message, tp)
                        setLoading(false)
                        //history.push('/')
                    }).catch(err => {
                        //console.log(err)
                        setLoading(false)
                        setShowvoucher(false)
                        setOTP({...OTP, openOtp: false})
                        const { message, type:tp } = err
                        handleOpenSnack(message, tp)
                        
                    }) 
                } else {
                    if(viewDialogOtp === false){
                        setOTP({...OTP, openOtp: false})
                    }
                    setLoading(false)
                    handleOpenSnack(message, typeMessage);
                }
            }
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack('El código OTP no es correcto. Por favor intente nuevamente.', 'error')
        }
        
    }

    const handleProcessPayment = ( {data}) => {
        try {
            setLoading(true)
            const { payerSelected } = formTaxe
            if ( sum('Valor', payerSelected) >accountSelected.Saldo) {
                handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
            } else {
                
                setFormTaxe({
                    ...formTaxe,
                    concept: data,
                    payerValue: sum('Valor', payerSelected)
                })
            }
        } catch (error) {
            //console.log(error)
        }
        
    }
    const handleOnCreditChange = (valueSelect) => {
        try {
            const data = valueSelect.split('-')
            if(data.length > 0) {
                //console.log(data[0])
                setDataCreditSelected(data[1])
                processGetCreditsAditionalPayment({SecuencialPrestamo: data[0]}).then(res => {
                    //console.log(res)
                    setCreditSelected(res.data)
                    setValuePay(res.data.ValorPagar)
                }).catch(err => {/* console.log(err) */})
            } else {
                setCreditSelected({})
            }
            
        } catch (error) {
            handleOpenSnack('Ha ocurrido un error en la solicitud. Por favor vuelva a intentar.', 'error')
        }
        
    }
    const handleSubmit = async(values) => {
        try {
            //console.log("Es IOS: ",isIOS)
            //console.log("# de Prestamo: ",dataCreditSelected)
            // console.log("# de Prestamo V2: ",values.NumeroPrestamo.split('-')[1])

            const resultFilterValueMinBalance = parameters.filter( (param) => param.name === "MINIMUM_BALANCE")
            const valueMinBalance = (resultFilterValueMinBalance.length > 0) ? resultFilterValueMinBalance[0].value : "2"

            if(dataCreditSelected.length > 0){
                setLoading(true)
                //const { payerSelected } = formTaxe
                // console.log(accountSelected, sum('Valor', payerSelected))
                if ( parseFloat(values.Valor) > accountSelected.SaldoCuenta) {
                    handleOpenSnack('El saldo es insuficiente para realizar la transacción.', 'error')
                    setLoading(false)
                } else {

                    if((parseFloat(accountSelected.SaldoCuenta) - parseFloat(values.Valor)) < parseFloat(valueMinBalance)){

                        setLoading(false)
                        handleOpenSnack('El valor del saldo mínimo no debe ser menor a $ '+valueMinBalance, 'error')
    
                    }else{
                        //console.log(devices)accountSelected.Codigo    dataCreditSelected
                        const { ip, mac, device } = devices
                        let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
                        values.Concepto = values.Concepto.toUpperCase()
                        //values.Valor = values.Valor
                        values.NumeroCuentaOrigen = accountSelected.Codigo
                        values.NumeroPrestamo = dataCreditSelected
                        values.Email = user.CorreoElectronico
                        values.dataDevice = {
                            ip,
                            device,
                            mac
                        }
                        values.NombreSocio = user.Nombres + " " + user.Apellidos;
                        values.IdentificacionSocio = user.Identificacion;
                        setCreditProcess(values)
                        GetOTP(20, ipSend, mac, device).then(res => {
                            setLoading(false)
                            //console.log(res)
                            setOTP({
                                ...OTP,
                                type: 'CREDIT_PROCESS',
                                openOtp: true
                            })
                        }).catch(err => {
                            //console.log(err)
                            setLoading(false)
                            handleOpenSnack('Ha ocurrido un error en la solicitud. Por favor vuelva a intentar.', 'error')
                        }) 
    
                    }
                }

            }else{
                handleOpenSnack('Debe seleccionar un Préstamo a cancelar.', 'error')
            }
        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack('Ha ocurrido un error en la solicitud. Por favor vuelva a intentar.', 'error')
        }
        
    }
    // renders
    const renderProcess = () => {
        // se renderiza el panel de informacion o el formulario para buscar las academias
        if (show) {
            return  <div>
                        <CreditsForm
                            loans = {credits.infoPayment}
                            creditSelected = { creditSelected }
                            onCreditChange = {handleOnCreditChange}
                            initialValues = { {Valor: valuePay, Concepto: ''}}
                            onSubmit = { handleSubmit }
                            valuePay = { valuePay}
                            onCancelAction = { () => history.push('/')} 
                            //showautofocus = {showautofocus}
                        />
                    </div>
        } else {
            return  <div>
                        {
                            (formTaxe.payersCode.length > 0 ) &&
                            <TaxeInfoPanel
                                select = { formTaxe.payerSelected}
                                options = {formTaxe.payersCode }
                                findValue = { (payerSelected) => {
                                    setFormTaxe({
                                        ...formTaxe,
                                        payerSelected
                                    })
                                }
                                } 
                                payerData = {formTaxe.payerData}
                                getBack = { setShow }
                                processPayment = { handleProcessPayment }
                            />
                        }
                        
                    </div>
        }
    }

    const handleSetNewPayment = () => {
        setShowvoucher(false)
        setShow(true)
        setDataresponse({})
    }

    const renderBody = () => {
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta de créditos.'} />
            } else {
                return  <UserPanelInfoMobile 
                        user = { user }
                        balances = {
                            balances
                        } 
                        accountSelected = { accountSelected }
                        changeAccount = { setAccountSelected }
                        handleAccountChange = {handleAccountChange}
                        dialog = {showDialogAccounts}
                    >
                        { (showvoucher === false) ? renderProcess() : 
                            <Voucher 
                                amount = { dataresponse.Valor }
                                titleheader = { "Valor cancelado" }
                                title = { "Comprobante" }
                                textButtonCancel = { "Nuevo Pago" }
                                handleCancel = { handleSetNewPayment }
                                databodyone = {
                                                [
                                                    {
                                                        title : "Socio:",
                                                        value : user.Nombres + " " + user.Apellidos,
                                                        order : 1
                                                    },
                                                    {
                                                        title : "C.I.:",
                                                        value : user.Identificacion,
                                                        order : 2
                                                    },
                                                    {
                                                        title : "Nro. de cuenta:",
                                                        value : accountSelected.Codigo,
                                                        order : 3
                                                    },
                                                    {
                                                        title : "Nro. de préstamo:",
                                                        value : dataresponse.NumeroPrestamo,
                                                        order : 4
                                                    },
                                                    {
                                                        title : "Valor inicial:",
                                                        value : "$ "+dataresponse.MontoPrestamo,
                                                        order : 5
                                                    },
                                                    {
                                                        title : "Fecha de pago",
                                                        value : moment(dataresponse.Fecha).format("YYYY/MM/DD"),
                                                        order : 6
                                                    },
                                                    {
                                                        title : "Nro. de transacción:",
                                                        value : dataresponse.NumeroDocumento,
                                                        order : 7
                                                    }
                                                ]
                                            }
                                handleDownloadVoucher = { handleDownloadVoucher }
                                handleDownloadDevice = { () => {
                                    try {
                                        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataresponse.Documento, name_voucher: dataresponse.name_voucher})().then(res => {
                                            if (res.error) {
                                                handleOpenSnack(res.message, 'error')
                                            } else {
                                                let send = {
                                                    type: 'action',
                                                    action: 'export_voucher',
                                                    data: urlVoucher+res.voucher+".pdf",
                                                    nameFile: res.voucher,
                                                    extension: 'pdf',
                                                    messageSend: 'Pago de Creditos'
                                                }
                                                sendMobile(JSON.stringify(send))
                                            }
                                        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                        
                                    } catch (error) {
                                        //console.log(error)
                                    }
                                }}
                            />
                        }
                    </UserPanelInfoMobile>
            }
            
        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta de créditos.'} />
            } else {
                return  <TaxeRenderBody
                        user = { user }
                        balances = { balances } 
                        accountSelected = { accountSelected }
                        changeAccount = { setAccountSelected } >
                        <TaxePanel>
                        { (showvoucher === false) ? renderProcess() : 
                            <Voucher 
                            amount = { dataresponse.Valor }
                            titleheader = { "Valor cancelado" }
                            title = { "Comprobante" }
                            textButtonCancel = { "Nuevo Pago" }
                            handleCancel = { handleSetNewPayment }
                            databodyone = {
                                            [
                                                {
                                                    title : "Socio:",
                                                    value : user.Nombres + " " + user.Apellidos,
                                                    order : 1
                                                },
                                                {
                                                    title : "C.I.:",
                                                    value : user.Identificacion,
                                                    order : 2
                                                },
                                                {
                                                    title : "Nro. de cuenta:",
                                                    value : accountSelected.Codigo,
                                                    order : 3
                                                },
                                                {
                                                    title : "Nro. de préstamo:",
                                                    value : dataresponse.NumeroPrestamo,
                                                    order : 4
                                                },
                                                {
                                                    title : "Valor inicial:",
                                                    value : "$ "+dataresponse.MontoPrestamo,
                                                    order : 5
                                                },
                                                {
                                                    title : "Fecha de pago",
                                                    value : moment(dataresponse.Fecha).format("YYYY/MM/DD"),
                                                    order : 6
                                                },
                                                {
                                                    title : "Nro. de transacción:",
                                                    value : dataresponse.NumeroDocumento,
                                                    order : 7
                                                }
                                            ]
                                        }
                            handleDownloadVoucher = { handleDownloadVoucher }
                            handleDownloadDevice = { () => {
                                try {
                                    feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataresponse.Documento, name_voucher: dataresponse.name_voucher})().then(res => {
                                        if (res.error) {
                                            handleOpenSnack(res.message, 'error')
                                        } else {
                                            let send = {
                                                type: 'action',
                                                action: 'export_voucher',
                                                data: urlVoucher+res.voucher+".pdf",
                                                nameFile: res.voucher,
                                                extension: 'pdf',
                                                messageSend: 'Pago de Creditos'
                                            }
                                            sendMobile(JSON.stringify(send))
                                        }
                                    }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                } catch (error) {
                                    //console.log(error)
                                }
                            }}
                        />
                        }
                        </TaxePanel>
                    </TaxeRenderBody>
            }
            
        }
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
            <LoadingScreen open={loading} />
            <StandardDialog
                open = {dialog.state}
                title = {dialog.title}
                handleClose = {() => cleanDialog() } >
                    {dialog.content}
            </StandardDialog>
            <DialogOTP
                openDialogOTP= { OTP.openOtp }
                onCloseDialogOTP = { () => setOTP({...OTP, openOtp: false})}
                initialTime = { Date.now()}
                showQR = {false}
                loading = {loading}
                onKeyPress = { handleChangeInputOtp }
                OTPSubmit = { handleOTPCompare }
            />
        </div>
    );
};

CreditsPayContainer.propTypes = {
    user: PropTypes.object.isRequired,
    balances: PropTypes.array.isRequired,
    handleOpenSnack: PropTypes.func.isRequired,
    credits: PropTypes.object.isRequired,
};

export default connect(null, {
    sendEmailWithVoucher,
    changeStatusUser,
    getBalanceUser
} )(CreditsPayContainer)

